const constants = {
  factorStep: 2.6,
  scaleStep: 18
};

export default constants;
